module.exports = __webpack_public_path__ + "img/tpo-logo.a9bfe319.jpg";